<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="content-modal-container">
                <div class="modal-header">
                    <div class="modal-title">
                        Редактировать контент
                    </div>

                    <div class="modal-header__close-button" @click="closeModal">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="#A8A8A8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>

                <div class="modal-body">
                    <div class="mb-4">
                        <div class="form-label">Тип файла</div>
                        <input type="text" class="form-control" v-model="contentTypeName" disabled>
                    </div>

                    <div class="mb-4">
                        <label class="form-label">Название <span class="color-red">*</span></label>
                        <input type="text" class="form-control" placeholder="..." v-model="itemToUpdate.name">
                    </div>

                    <div class="mb-4">
                        <label class="form-label">Продолжительность</label>
                        <input type="time" step="1" class="form-control" placeholder="..." id="content-duration" v-model="itemToUpdate.duration">
                    </div>

                    <div class="form-check">
                        <label class="form-check-label" for="is_statistics_enabled">
                            Сбор статистики показов
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               id="is_statistics_enabled"
                               v-model="itemToUpdate.is_statistics_enabled">
                    </div>
                </div>

                <div class="modal-footer">
                    <ConfirmBtn :class="'btn btn-md btn-primary me-2'" :text="'Сохранить'" @btnClick="saveContent"/>
                    <button @click="closeModal" class="btn btn-md btn-outline-dark" type="button">
                        <span>Отменить</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <Alert />
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex/dist/vuex.cjs.js';
import ConfirmBtn from '../elements/ConfirmBtn.vue';
import Alert from '../components/alerts/Alert.vue';

export default {
    name: 'EditContentModal',

    components: { ConfirmBtn, Alert },

    props: {
        typeFile: {
            type: [String, Number]
        },
        typeDirectory: {
            type: [String, Number]
        },
    },

    data() {
        return {
            name: '',
            alertMessage: '',
            localDuration: null,
            isStatisticsEnabled: false,
        }
    },

    computed: {
        ...mapState('content', ['itemToUpdate']),

        contentTypeName() {
            if (this.itemToUpdate.type_id == 1) {
                return 'Изображение';
            } else if (this.itemToUpdate.type_id == 2) {
                return 'Видео';
            }
        },
    },

    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('content', ['closeEditContentModal']),
        ...mapActions('content', ['editContent']),

        saveContent() {
            if (!this.itemToUpdate.name.length) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите название' });
                return
            }

            const parts = this.itemToUpdate.duration.split(':');

            const hours = parseInt(parts[0]);
            const minutes = parseInt(parts[1]);
            const seconds = parseInt(parts[2]);

            const totalSeconds = (hours * 3600) + (minutes * 60) + seconds;

            if (isNaN(totalSeconds) || totalSeconds < 5) {
                this.$emit('invalidDuration', 'Длительность контента не может быть менее 5 секунд.')
                return;
            }

            this.editContent();
        },

        closeModal() {
            this.itemToUpdate.name = this.name;
            this.itemToUpdate.duration = this.localDuration;
            this.itemToUpdate.is_statistics_enabled = this.isStatisticsEnabled;
            this.closeEditContentModal();
        },
    },

    mounted() {
        this.name = this.itemToUpdate.name;
        this.localDuration = this.itemToUpdate.duration;
        this.isStatisticsEnabled = this.itemToUpdate.is_statistics_enabled
    }
}

</script>

<style scoped lang="scss">

</style>
